module.exports = __webpack_public_path__ + "img/coming-soon-1.e035f8b8.png";